/**
 * In-app anchor styled as a text link; same-origin **`href`** values participate in SPA navigation when handled by the shell.
 *
 * @param href - Path or URL fragment for navigation.
 * @param label - Visible link text (catalog-backed).
 * @returns Anchor with **`qz-link`** class.
 */
export function createAppLink(href: string, label: string): HTMLAnchorElement {
  const a = document.createElement("a");
  a.href = href;
  a.textContent = label;
  a.className = "qz-link";
  return a;
}
